import {
    apiRequest,
    configTunjanganCreate
} from "../../../../../services/adapters/kepegawaian/configTunjanganService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", configTunjanganCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository